import type { User } from '@entities/user';
import { CorrectUserInfo } from '@main/utils/correct-user-info';
import { SalesforceUserSetup } from '@main/utils/salesforce-user-setup';
import type { UserLoginEventPublisher } from '@usecases/user-login.usecase';

export class UserLoginPublisher implements UserLoginEventPublisher {
  async publish(user: User): Promise<void> {
    const correctedInfo = await CorrectUserInfo.correct(user.info);
    SalesforceUserSetup.init(correctedInfo);
  }
}
